/**
 * ContainerREADY two-stage post-ATC offer.
 * Stage 1: SkyDOME-only. Stage 2: contained ContainerREADY Windows reveal.
 * Cart drawer: compact More Upgrades cards.
 * Does not globally wrap /cart/add. Does not intercept Buy Now.
 */
(function () {
  'use strict';

  var SESSION_KEY = 'cc_project_offer_shown';
  var root = document.getElementById('cc-post-atc-offer');
  var settingsEl = document.getElementById('cc-post-atc-settings');

  /* Live catalog handles only (verified 2026-09-09).
   * Note: 40-foot-container-roof-vent-system-copy is the LIVE 20′ package title. */
  var DEFAULT_TRIGGER_HANDLES = [
    'shipping-container-roof-vent-adapter',
    'shipping-container-roof-vent-adapter-10pack',
    'adaptair™-roof-vent-adapter-for-shipping-containers',
    '40-foot-container-roof-vent-system-copy',
    'roof-vent-system-40-foot-container-2-adaptair™-vent-2-whirlybird-turbine-copy'
  ];
  var DEFAULT_SUPPRESS_SKYDOME = ['shipping-container-skylight', 'skylight', 'skydome'];
  var DEFAULT_SUPPRESS_WD = ['window', 'door'];
  var NEVER_TRIGGER = [
    'conex-container-intake-vents',
    '3-inch-louver-vents-4-pack',
    'shipping-container-skylight',
    'skydome™-skylight-for-shipping-containers-bundle-upgrade',
    'skylight-adapter-large-corrugation',
    'universal-shipping-container-skylight',
    'no-weld-shipping-container-window-installation-kit',
    'no-weld-shipping-container-door-installation-kit',
    'chemlink-m1-roofing-adhesive',
    '12-inch-whirlybird-turbine',
    'uscc-01-for-type-a-corrugation'
  ];

  var cfg = { enabled: false, drawerRecsEnabled: false };
  if (settingsEl) {
    try {
      cfg = JSON.parse(settingsEl.textContent || '{}');
    } catch (e) {
      cfg = {};
    }
  }

  function parseList(str) {
    if (!str || typeof str !== 'string') return [];
    return str
      .split(',')
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function normalizeVariantId(v) {
    if (v === null || v === undefined || v === '') return '';
    if (typeof v === 'number' && (v === 0 || !isFinite(v))) return '';
    var n = String(v).replace(/\D/g, '');
    if (!n || /^0+$/.test(n)) return '';
    return n;
  }

  function isValidUrl(url) {
    if (!url || typeof url !== 'string') return false;
    var u = url.trim();
    if (!u || u === '#' || u === '/' || u === 'undefined' || u === 'null') return false;
    return true;
  }

  cfg.skydomeVariantId = normalizeVariantId(cfg.skydomeVariantId);
  cfg.triggerHandles = parseList(cfg.triggerHandles);
  cfg.triggerTypes = parseList(cfg.triggerTypes);
  cfg.suppressSkydomeHandles = parseList(cfg.suppressSkydomeHandles);
  cfg.suppressSkydomeTypes = parseList(cfg.suppressSkydomeTypes);
  cfg.suppressWdHandles = parseList(cfg.suppressWdHandles);
  cfg.suppressWdTypes = parseList(cfg.suppressWdTypes);
  cfg.cartAddUrl = cfg.cartAddUrl || '/cart/add.js';
  cfg.wdUrl = typeof cfg.wdUrl === 'string' ? cfg.wdUrl.trim() : '';
  cfg.popupEnabled = cfg.enabled !== false;
  cfg.mobileEnabled = cfg.mobileEnabled === true;
  cfg.drawerRecsEnabled = cfg.drawerRecsEnabled !== false;
  cfg.hasWdVideo = !!cfg.hasWdVideo;
  cfg.hasWdImage = !!cfg.hasWdImage;

  if (!cfg.triggerHandles.length && !cfg.triggerTypes.length) {
    cfg.triggerHandles = DEFAULT_TRIGGER_HANDLES.slice();
  }
  if (!cfg.suppressSkydomeHandles.length) {
    cfg.suppressSkydomeHandles = DEFAULT_SUPPRESS_SKYDOME.slice();
  }
  if (!cfg.suppressWdHandles.length) {
    cfg.suppressWdHandles = DEFAULT_SUPPRESS_WD.slice();
  }

  var holdDrawer = false;
  var open = false;
  var currentStage = 0;
  var lastFocus = null;
  var pendingTimer = null;
  var lastTriggerKey = '';
  var addingSkydome = false;
  var skipNextEvaluate = false;
  var revealStarted = false;
  var reducedMotion = false;

  try {
    reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    reducedMotion = false;
  }

  var stage1Panel = root ? root.querySelector('[data-cc-stage-panel="1"]') : null;
  var stage2Panel = root ? root.querySelector('[data-cc-stage-panel="2"]') : null;
  var skydomeBtn = root ? root.querySelector('[data-cc-skydome-add]') : null;
  var skydomeDecline = root ? root.querySelector('[data-cc-skydome-decline]') : null;
  var wdLink = root ? root.querySelector('[data-cc-wd-link]') : null;
  var revealContinue = root ? root.querySelector('[data-cc-reveal-continue]') : null;
  var dismissEls = root ? root.querySelectorAll('[data-cc-post-atc-dismiss]') : [];
  var revealMedia = root ? root.querySelector('[data-cc-reveal-media]') : null;
  var revealDialog = root ? root.querySelector('[data-cc-reveal-dialog]') : null;
  var revealVideoWrap = root ? root.querySelector('[data-cc-reveal-video-wrap]') : null;
  var revealStillWrap = root ? root.querySelector('[data-cc-reveal-still-wrap]') : null;
  var revealPlayBtn = root ? root.querySelector('[data-cc-reveal-play]') : null;
  var revealCopy = root ? root.querySelector('[data-cc-reveal-copy]') : null;
  var videoAspect = 0;
  var revealResizeBound = false;
  var focusableSelector =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  function listHas(list, value) {
    if (!value) return false;
    var v = String(value).toLowerCase();
    return list.indexOf(v) !== -1;
  }

  function handleMatches(list, handle) {
    if (!handle) return false;
    var h = String(handle).toLowerCase();
    if (listHas(list, h)) return true;
    for (var i = 0; i < list.length; i++) {
      if (list[i] && h.indexOf(list[i]) !== -1) return true;
    }
    return false;
  }

  function typeMatches(list, productType) {
    if (!productType) return false;
    return listHas(list, productType);
  }

  function cartItems(cart) {
    return (cart && cart.items) || [];
  }

  function cartHasVariant(cart, variantId) {
    if (!variantId) return false;
    var items = cartItems(cart);
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(variantId) || String(items[i].id) === String(variantId)) {
        return true;
      }
    }
    return false;
  }

  function cartMatchesList(cart, handles, types) {
    var items = cartItems(cart);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var h = (item.handle || '').toLowerCase();
      var t = (item.product_type || '').toLowerCase();
      if (handleMatches(handles, h) || typeMatches(types, t)) return true;
    }
    return false;
  }

  function cartIsEmpty(cart) {
    return !cart || !cart.item_count;
  }

  function shouldTrigger(handle, productType) {
    var h = (handle || '').toLowerCase();
    var t = (productType || '').toLowerCase();
    if (!h && !t) return false;
    if (handleMatches(NEVER_TRIGGER, h)) return false;
    if (h.indexOf('intake') !== -1) return false;
    if (h.indexOf('skylight') !== -1 || h.indexOf('skydome') !== -1) return false;
    if (h.indexOf('window') !== -1 || h.indexOf('door') !== -1) return false;
    return handleMatches(cfg.triggerHandles, h) || typeMatches(cfg.triggerTypes, t);
  }

  function shouldShowSkydome(cart, addedHandle, addedType) {
    if (!cfg.skydomeVariantId) return false;
    if (cartHasVariant(cart, cfg.skydomeVariantId)) return false;
    if (handleMatches(cfg.suppressSkydomeHandles, addedHandle)) return false;
    if (typeMatches(cfg.suppressSkydomeTypes, addedType)) return false;
    if (cartMatchesList(cart, cfg.suppressSkydomeHandles, cfg.suppressSkydomeTypes)) return false;
    return true;
  }

  function shouldShowWindowsDoors(cart, addedHandle, addedType) {
    if (!isValidUrl(cfg.wdUrl)) return false;
    if (handleMatches(cfg.suppressWdHandles, addedHandle)) return false;
    if (typeMatches(cfg.suppressWdTypes, addedType)) return false;
    if (cartMatchesList(cart, cfg.suppressWdHandles, cfg.suppressWdTypes)) return false;
    return true;
  }

  function isPhoneViewport() {
    try {
      if (window.matchMedia) {
        return window.matchMedia('(max-width: 767px)').matches;
      }
    } catch (e) {}
    return (window.innerWidth || document.documentElement.clientWidth || 800) < 768;
  }

  function sessionOfferShown() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSessionOfferShown() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  function clearSessionOfferShown() {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return { items: [], item_count: 0 };
      });
  }

  function getSectionInnerHTML(html, selector) {
    if (!html) return '';
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function applySectionsHtml(sectionsMap, openDrawer) {
    if (!sectionsMap) return;
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && sectionsMap['cart-drawer']) {
      var drawerInner = getSectionInnerHTML(sectionsMap['cart-drawer'], '.cart-drawer');
      if (drawerInner) {
        drawer.innerHTML = drawerInner;
      } else {
        var parsed = new DOMParser().parseFromString(sectionsMap['cart-drawer'], 'text/html');
        var next = parsed.querySelector('.cart-drawer');
        if (next) drawer.innerHTML = next.innerHTML;
      }
      if (typeof CartDrawer !== 'undefined') {
        try {
          new CartDrawer();
        } catch (err) {}
      }
      if (openDrawer) {
        document.body.classList.add('open-cc');
        drawer.classList.add('active');
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart-drawer:open');
        }
      }
      refreshDrawerRecsVisibility();
    }
    if (sectionsMap['cart-bubble']) {
      var bubbleHtml = getSectionInnerHTML(sectionsMap['cart-bubble'], '.thb-item-count');
      var bubbleCurrent = document.querySelector('#cart-drawer-toggle .thb-item-count, .thb-item-count');
      if (bubbleHtml && bubbleCurrent) bubbleCurrent.innerHTML = bubbleHtml;
    }
  }

  function refreshCartDrawer(sectionsFromAdd, openDrawer) {
    var shouldOpen = openDrawer !== false;
    if (sectionsFromAdd) {
      applySectionsHtml(sectionsFromAdd, shouldOpen);
      return Promise.resolve();
    }
    var sections = 'cart-drawer,cart-bubble';
    var path = window.location.pathname || '/';
    return fetch(path + '?sections=' + encodeURIComponent(sections), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (sectionsHtml) {
        applySectionsHtml(sectionsHtml, shouldOpen);
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    holdDrawer = false;
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    document.body.classList.add('open-cc');
    drawer.classList.add('active');
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart-drawer:open');
    }
    refreshDrawerRecsVisibility();
  }

  function activeDialog() {
    if (currentStage === 1 && stage1Panel) {
      return stage1Panel.querySelector('.cc-post-atc__dialog');
    }
    if (currentStage === 2 && stage2Panel) {
      return stage2Panel.querySelector('.cc-post-atc__dialog');
    }
    return null;
  }

  function getFocusable() {
    var dialog = activeDialog();
    if (!dialog) return [];
    return Array.prototype.slice.call(dialog.querySelectorAll(focusableSelector)).filter(function (el) {
      if (el.closest('[hidden]')) return false;
      return !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true';
    });
  }

  function trapFocus(e) {
    if (!open || e.key !== 'Tab') return;
    var nodes = getFocusable();
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (!open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      dismissToCart();
      return;
    }
    trapFocus(e);
  }

  function stopRevealMedia() {
    revealStarted = false;
    if (!revealVideoWrap) return;
    var video = revealVideoWrap.querySelector('video');
    if (video) {
      try {
        video.pause();
        video.removeEventListener('ended', onRevealVideoEnded);
      } catch (err) {}
    }
  }

  function hidePlayControl() {
    if (revealPlayBtn) revealPlayBtn.hidden = true;
    if (root) root.classList.remove('cc-post-atc--reveal-awaiting');
  }

  function resetRevealVisuals() {
    stopRevealMedia();
    hidePlayControl();
    if (root) {
      root.classList.remove('cc-post-atc--reveal-still');
      root.classList.remove('cc-post-atc--reveal-playing');
      root.classList.remove('cc-post-atc--reveal-awaiting');
    }
    if (revealStillWrap) {
      revealStillWrap.classList.remove('cc-post-atc__reveal-still-wrap--active');
      revealStillWrap.hidden = false;
    }
    if (revealVideoWrap) {
      revealVideoWrap.classList.remove('cc-post-atc__reveal-video-wrap--fading');
      revealVideoWrap.hidden = false;
    }
  }

  function sizeRevealModal() {
    if (!revealDialog || !revealMedia || !revealCopy) return;
    var vw = window.innerWidth || document.documentElement.clientWidth || 800;
    var vh = window.innerHeight || document.documentElement.clientHeight || 600;
    var isMobile = vw < 768;
    var sidePad = isMobile ? 24 : 48;
    var vertPad = isMobile ? 24 : 64;
    var maxModalW = Math.min(800, Math.max(280, vw - sidePad));
    var maxModalH = Math.max(320, vh - vertPad);

    revealDialog.style.width = maxModalW + 'px';
    revealDialog.style.maxWidth = maxModalW + 'px';

    var chrome = revealDialog.querySelector('.cc-post-atc__reveal-chrome');
    var chromeH = chrome ? chrome.offsetHeight : 44;
    /* Reserve enough room for headline + both CTAs so Continue to cart is never clipped */
    var measuredCopy = revealCopy.offsetHeight || 0;
    var copyH = Math.max(measuredCopy, isMobile ? 210 : 170);
    var minMedia = isMobile ? 96 : 140;
    var maxMedia = isMobile ? Math.min(180, Math.floor(vh * 0.28)) : 480;
    var availMediaH = Math.max(minMedia, Math.min(maxMedia, maxModalH - chromeH - copyH));
    var availMediaW = maxModalW;

    var ratio = videoAspect > 0 ? videoAspect : 16 / 9;
    var mediaW = availMediaW;
    var mediaH = mediaW / ratio;
    if (mediaH > availMediaH) {
      mediaH = availMediaH;
      mediaW = mediaH * ratio;
    }

    var finalW = Math.max(280, Math.round(mediaW));
    revealDialog.style.width = finalW + 'px';
    revealMedia.style.height = Math.round(mediaH) + 'px';
    revealMedia.style.maxHeight = maxMedia + 'px';
  }

  function applyPlaybackRate(video) {
    if (!video) return;
    try {
      video.playbackRate = 1;
      video.defaultPlaybackRate = 1;
    } catch (err) {}
  }

  function activateStill() {
    hidePlayControl();
    if (root) {
      root.classList.add('cc-post-atc--reveal-still');
      root.classList.remove('cc-post-atc--reveal-playing');
    }
    if (revealStillWrap) {
      revealStillWrap.hidden = false;
      revealStillWrap.classList.add('cc-post-atc__reveal-still-wrap--active');
    }
    if (revealVideoWrap) {
      revealVideoWrap.classList.add('cc-post-atc__reveal-video-wrap--fading');
      window.setTimeout(function () {
        if (revealVideoWrap) revealVideoWrap.hidden = true;
      }, 900);
    }
    sizeRevealModal();
  }

  function showAwaitingPlay(video) {
    if (video) {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (err) {}
    }
    if (root) {
      root.classList.add('cc-post-atc--reveal-awaiting');
      root.classList.remove('cc-post-atc--reveal-playing');
      root.classList.remove('cc-post-atc--reveal-still');
    }
    if (revealStillWrap) {
      revealStillWrap.hidden = false;
      revealStillWrap.classList.add('cc-post-atc__reveal-still-wrap--active');
    }
    if (revealVideoWrap) {
      revealVideoWrap.classList.remove('cc-post-atc__reveal-video-wrap--fading');
      revealVideoWrap.hidden = false;
    }
    if (revealPlayBtn) revealPlayBtn.hidden = false;
    sizeRevealModal();
  }

  function showPlaying() {
    hidePlayControl();
    if (root) {
      root.classList.add('cc-post-atc--reveal-playing');
      root.classList.remove('cc-post-atc--reveal-still');
      root.classList.remove('cc-post-atc--reveal-awaiting');
    }
    if (revealStillWrap) {
      revealStillWrap.classList.remove('cc-post-atc__reveal-still-wrap--active');
    }
    if (revealVideoWrap) {
      revealVideoWrap.hidden = false;
      revealVideoWrap.classList.remove('cc-post-atc__reveal-video-wrap--fading');
    }
    sizeRevealModal();
  }

  function prepareCommercial(video) {
    video.muted = false;
    video.defaultMuted = false;
    video.removeAttribute('muted');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    video.loop = false;
    video.controls = false;
    try {
      video.currentTime = 0;
    } catch (err) {}
    applyPlaybackRate(video);
  }

  function playCommercialWithSound(video) {
    prepareCommercial(video);
    bindVideoMetadata(video);
    video.removeEventListener('ended', onRevealVideoEnded);
    video.addEventListener('ended', onRevealVideoEnded);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      return playPromise
        .then(function () {
          if (video.muted) {
            try {
              video.pause();
            } catch (err) {}
            showAwaitingPlay(video);
            return false;
          }
          showPlaying();
          return true;
        })
        .catch(function () {
          showAwaitingPlay(video);
          return false;
        });
    }
    if (video.paused || video.muted) {
      showAwaitingPlay(video);
      return Promise.resolve(false);
    }
    showPlaying();
    return Promise.resolve(true);
  }

  function onRevealVideoEnded() {
    activateStill();
  }

  function bindVideoMetadata(video) {
    if (!video) return;
    var applyMeta = function () {
      if (video.videoWidth > 0 && video.videoHeight > 0) {
        videoAspect = video.videoWidth / video.videoHeight;
        sizeRevealModal();
      }
    };
    if (video.readyState >= 1 && video.videoWidth > 0) {
      applyMeta();
    } else {
      video.addEventListener('loadedmetadata', applyMeta, { once: true });
    }
  }

  function startRevealSequence() {
    if (revealStarted) return;
    revealStarted = true;
    sizeRevealModal();

    if (!revealResizeBound) {
      revealResizeBound = true;
      window.addEventListener('resize', function () {
        if (currentStage === 2) sizeRevealModal();
      });
    }

    var hasVideo = cfg.hasWdVideo && revealVideoWrap && revealVideoWrap.querySelector('video');

    if (!hasVideo) {
      if (revealVideoWrap) revealVideoWrap.hidden = true;
      activateStill();
      return;
    }

    var video = revealVideoWrap.querySelector('video');
    if (revealPlayBtn && !revealPlayBtn.getAttribute('data-cc-bound')) {
      revealPlayBtn.setAttribute('data-cc-bound', '1');
      revealPlayBtn.addEventListener('click', function () {
        playCommercialWithSound(video);
      });
    }

    if (reducedMotion) {
      showAwaitingPlay(video);
      return;
    }

    try {
      playCommercialWithSound(video);
    } catch (err) {
      showAwaitingPlay(video);
    }
  }

  function setStagePanels(stage) {
    currentStage = stage;
    if (root) root.setAttribute('data-cc-stage', String(stage));
    if (stage1Panel) {
      if (stage === 1) stage1Panel.removeAttribute('hidden');
      else stage1Panel.setAttribute('hidden', '');
    }
    if (stage2Panel) {
      if (stage === 2) stage2Panel.removeAttribute('hidden');
      else stage2Panel.setAttribute('hidden', '');
    }
    if (stage === 1) {
      root.setAttribute('aria-labelledby', 'cc-post-atc-stage1-title');
    } else if (stage === 2) {
      root.setAttribute('aria-labelledby', 'cc-post-atc-stage2-title');
    }
  }

  function ensureRootOpen() {
    if (!root) return;
    lastFocus = lastFocus || document.activeElement;
    root.hidden = false;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('cc-post-atc--open');
    document.documentElement.classList.add('cc-post-atc-open');
    if (!open) {
      open = true;
      document.addEventListener('keydown', onKeydown);
      markSessionOfferShown();
    }
  }

  function closeOfferOnly() {
    if (!open && (!root || root.hidden)) return;
    open = false;
    currentStage = 0;
    resetRevealVisuals();
    if (!root) return;
    root.hidden = true;
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
    root.classList.remove('cc-post-atc--open');
    document.documentElement.classList.remove('cc-post-atc-open');
    document.removeEventListener('keydown', onKeydown);
    if (stage1Panel) stage1Panel.setAttribute('hidden', '');
    if (stage2Panel) stage2Panel.setAttribute('hidden', '');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try {
        lastFocus.focus();
      } catch (err) {}
    }
    lastFocus = null;
  }

  /** Always clear hold + open drawer — use on dismiss, Escape, and any error path. */
  function releaseHoldAndOpenCart() {
    holdDrawer = false;
    if (pendingTimer) {
      window.clearTimeout(pendingTimer);
      pendingTimer = null;
    }
    try {
      closeOfferOnly();
    } catch (err) {
      console.error(err);
    }
    try {
      openCartDrawer();
    } catch (err) {
      console.error(err);
    }
  }

  function dismissToCart() {
    releaseHoldAndOpenCart();
  }

  function openStage1() {
    try {
      resetRevealVisuals();
      ensureRootOpen();
      setStagePanels(1);
      window.setTimeout(function () {
        var closeBtn = stage1Panel && stage1Panel.querySelector('.cc-post-atc__close');
        if (closeBtn) closeBtn.focus();
        else if (skydomeBtn) skydomeBtn.focus();
      }, 10);
    } catch (err) {
      console.error(err);
      releaseHoldAndOpenCart();
    }
  }

  function openStage2() {
    try {
      ensureRootOpen();
      setStagePanels(2);
      if (wdLink && isValidUrl(cfg.wdUrl)) {
        wdLink.setAttribute('href', cfg.wdUrl);
      }
      window.setTimeout(function () {
        try {
          startRevealSequence();
          sizeRevealModal();
          if (revealContinue) {
            try {
              revealContinue.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            } catch (e2) {}
          }
          var closeBtn = stage2Panel && stage2Panel.querySelector('.cc-post-atc__close');
          if (closeBtn) closeBtn.focus();
        } catch (err) {
          console.error(err);
          releaseHoldAndOpenCart();
        }
      }, 10);
    } catch (err) {
      console.error(err);
      releaseHoldAndOpenCart();
    }
  }

  function addSkydome(fromDrawer) {
    if (!cfg.skydomeVariantId || addingSkydome) return;
    var btn = fromDrawer
      ? document.querySelector('[data-cc-drawer-skydome-add]')
      : skydomeBtn;
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
    }
    addingSkydome = true;
    skipNextEvaluate = true;

    var formData = new FormData();
    formData.append('id', cfg.skydomeVariantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer,cart-bubble');
    formData.append('sections_url', window.location.pathname || '/');

    fetch(cfg.cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript'
      },
      body: formData
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add SkyDOME');
        }
        return refreshCartDrawer(res.data.sections || null, !!fromDrawer);
      })
      .then(function () {
        if (fromDrawer) {
          refreshDrawerRecsVisibility();
          return;
        }
        openStage2();
      })
      .catch(function (err) {
        if (!fromDrawer) {
          var copy = stage1Panel && stage1Panel.querySelector('.cc-post-atc__skydome-copy');
          if (copy) {
            var existing = copy.querySelector('.cc-post-atc__status--error');
            if (existing) existing.remove();
            var note = document.createElement('p');
            note.className = 'cc-post-atc__status cc-post-atc__status--error';
            note.textContent = err && err.message ? err.message : 'Could not add SkyDOME. Please try again.';
            copy.appendChild(note);
          }
          /* Do not trap the shopper — release hold so Checkout is reachable */
          holdDrawer = false;
        }
        if (btn) {
          btn.removeAttribute('aria-disabled');
          btn.disabled = false;
        }
      })
      .finally(function () {
        addingSkydome = false;
        window.setTimeout(function () {
          skipNextEvaluate = false;
        }, 800);
      });
  }

  function evaluateAndMaybeOpen(detail) {
    detail = detail || {};
    try {
      if (!cfg.popupEnabled || !root) return;
      if (!cfg.mobileEnabled && isPhoneViewport()) return;
      if (addingSkydome || skipNextEvaluate) return;

      var product = detail.product || {};
      var handle = (detail.handle || product.handle || '').toLowerCase();
      var productType = (detail.productType || product.product_type || '').toLowerCase();
      var variantId = detail.productVariantId || product.variant_id || product.id || '';

      if (!shouldTrigger(handle, productType)) return;

      var now = Date.now();
      if (lastTriggerKey) {
        var parts = lastTriggerKey.split('|');
        if (parts[0] === handle && now - Number(parts[2] || 0) < 1200) return;
      }
      lastTriggerKey = handle + '|' + variantId + '|' + now;

      if (sessionOfferShown()) {
        holdDrawer = false;
        return;
      }

      holdDrawer = true;

      if (pendingTimer) window.clearTimeout(pendingTimer);
      pendingTimer = window.setTimeout(function () {
        fetchCart()
          .then(function (cart) {
            if (cartIsEmpty(cart)) {
              clearSessionOfferShown();
            }

            if (sessionOfferShown()) {
              holdDrawer = false;
              openCartDrawer();
              return;
            }

            var showSkydome = shouldShowSkydome(cart, handle, productType);
            var showWd = shouldShowWindowsDoors(cart, handle, productType);

            if (showSkydome) {
              openStage1();
            } else if (showWd) {
              openStage2();
            } else {
              holdDrawer = false;
              openCartDrawer();
            }
          })
          .catch(function () {
            holdDrawer = false;
            openCartDrawer();
          });
      }, 50);

      window.setTimeout(function () {
        if (holdDrawer && !open) {
          holdDrawer = false;
          openCartDrawer();
        }
      }, 4000);
    } catch (err) {
      console.error(err);
      releaseHoldAndOpenCart();
    }
  }

  function refreshDrawerRecsVisibility() {
    // Mobile purchase path: no cart-drawer upsells (checkout is the next step after ATC).
    if (!cfg.drawerRecsEnabled || isPhoneViewport()) {
      var allOff = document.querySelectorAll('[data-cc-project-drawer-recs]');
      Array.prototype.forEach.call(allOff, function (el) {
        el.hidden = true;
        el.setAttribute('hidden', '');
      });
      return;
    }
    fetchCart().then(function (cart) {
      if (cartIsEmpty(cart)) {
        clearSessionOfferShown();
      }
      var showSkydome = shouldShowSkydome(cart, '', '');
      var showWd = shouldShowWindowsDoors(cart, '', '');
      var blocks = document.querySelectorAll('[data-cc-project-drawer-recs]');
      Array.prototype.forEach.call(blocks, function (block) {
        var sCard = block.querySelector('[data-cc-drawer-card="skydome"]');
        var wCard = block.querySelector('[data-cc-drawer-card="windows-doors"]');
        if (sCard) {
          if (showSkydome) sCard.removeAttribute('hidden');
          else sCard.setAttribute('hidden', '');
        }
        if (wCard) {
          if (showWd) {
            wCard.removeAttribute('hidden');
            var link = wCard.querySelector('[data-cc-drawer-wd-link]');
            if (link && isValidUrl(cfg.wdUrl)) link.setAttribute('href', cfg.wdUrl);
          } else {
            wCard.setAttribute('hidden', '');
          }
        }
        block.hidden = !(showSkydome || showWd);
        if (showSkydome || showWd) block.removeAttribute('hidden');
        else block.setAttribute('hidden', '');
      });
    });
  }

  window.CCProjectOffer = {
    shouldHoldDrawer: function () {
      return !!holdDrawer;
    },
    openCartDrawer: openCartDrawer,
    releaseHoldAndOpenCart: releaseHoldAndOpenCart,
    refreshDrawerRecs: refreshDrawerRecsVisibility,
    addSkydomeFromDrawer: function () {
      addSkydome(true);
    },
    cfg: cfg
  };

  if (root && cfg.popupEnabled) {
    document.addEventListener('cart:item-added', function (event) {
      var detail = (event && event.detail) || {};
      evaluateAndMaybeOpen(detail);
    });

    Array.prototype.forEach.call(dismissEls, function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        dismissToCart();
      });
    });

    if (skydomeBtn) {
      skydomeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addSkydome(false);
      });
    }

    if (skydomeDecline) {
      skydomeDecline.addEventListener('click', function (e) {
        e.preventDefault();
        openStage2();
      });
    }

    if (revealContinue) {
      revealContinue.addEventListener('click', function (e) {
        e.preventDefault();
        dismissToCart();
      });
    }

    if (wdLink) {
      wdLink.addEventListener('click', function () {
        holdDrawer = false;
        try {
          closeOfferOnly();
        } catch (err) {
          console.error(err);
        }
      });
    }
  }

  document.addEventListener('cart-drawer:open', refreshDrawerRecsVisibility);
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-cc-drawer-skydome-add]');
    if (!btn) return;
    e.preventDefault();
    addSkydome(true);
  });
  refreshDrawerRecsVisibility();
})();
